/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateCustomFieldsSchemaRequest } from '../../models/create-custom-fields-schema-request';
import { CustomFieldsSchemaDto } from '../../models/custom-fields-schema-dto';

export interface CreateCustomFieldsSchema$Params {
      body: CreateCustomFieldsSchemaRequest
}

export function createCustomFieldsSchema(http: HttpClient, rootUrl: string, params: CreateCustomFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomFieldsSchemaDto>> {
  const rb = new RequestBuilder(rootUrl, createCustomFieldsSchema.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomFieldsSchemaDto>;
    })
  );
}

createCustomFieldsSchema.PATH = '/v0/CustomFieldsSchema/{id}';
